export default __webpack_public_path__ + "static/media/facebook.28ba4b49.svg";